'use es6';
/**
 * @typedef {Object} Position
 * @property {String} BOTTOM
 * @property {String} TOP
 */

/**
 * Enum of position.
 *
 * @enum {String}
 * @readonly
 */

export default Object.freeze({
  BOTTOM: 'bottom',
  TOP: 'top'
});